export function languageToggle()
{
    let englishIcon = document.querySelector("#menu-item-574");
    let frenchIcon = document.querySelector("#menu-item-573");
    let t = window.location.href.indexOf('/fr/');

    if (t == -1)
    {
        englishIcon.style.opacity = 1;
        frenchIcon.style.opacity = 0.5;
    }
    else
    {
        englishIcon.style.opacity = 0.5;
        frenchIcon.style.opacity = 1;
    }
}

// Click on hamburger menu and rotate bars
export function navMenu()
{

    const hamburger = document.querySelector('.hamburger-module');
    const navigationMenu = document.querySelector('.navigation-menu');
    const navbar = document.querySelector('.navbar');
    const infomenu = document.querySelector('.info-wrapper');

    
    hamburger.addEventListener('click', () => {
        
        if (!hamburger.classList.contains('active')) {
            hamburger.classList.toggle("active");
            navbar.style.opacity = 1;
            navigationMenu.classList.toggle("active");
            document.body.style.overflow = "hidden";

        } else {
            hamburger.classList.toggle("active");
            navbar.style.opacity = 0;
            navigationMenu.classList.toggle("active");
            document.body.style.overflow = "";
        }
    })
}

// Click on nav menu link and open and close the sub menus
// export function hamburgerSubMenu()
// {
//     let navMenuList = document.querySelectorAll('#menu-navbar-menu > li');

//     navMenuList.forEach((el) => {
//         if (el.querySelector("ul"))
//         {
//             el.addEventListener("click", (event) => {
//                 // console.log(event);
//                 navMenuList.forEach(elm => {
//                     // reset all dropdowns 
//                     if (elm.querySelector("ul"))
//                     {
//                         elm.querySelector("ul").classList.remove('active');
//                         elm.querySelector("i").classList.remove('rotate');
//                     }
//                 });
//                     // Activate dropdown that has been triggered
//                     el.querySelector("ul").classList.add('active');
//                     el.querySelector("i").classList.add('rotate');
                
//             })
//         }
//     })
// }

// export function clearHamburgerMenu()
// {
//     let navMenuList = document.querySelectorAll('#menu-navbar-menu > li');

//     navMenuList.forEach((el) => {
//         el.querySelector("ul").classList.remove('active');
//         el.querySelector("i").classList.remove('rotate');
//     })
// }

// Add nav icons to the nav menu
// export function navIcons()
// {
//     let navMenu = document.querySelector('#menu-navbar-menu').querySelectorAll("li");
//     // console.log(navMenu);
//     navMenu.forEach(el => {
//         if (el.querySelector("ul"))
//         {
//             el.querySelector("ul").insertAdjacentHTML("beforebegin", '<i class="fa-solid fa-sort-down fa-xl"></i>')
//         }
//     })
// }